import _ from 'lodash';
import { goto } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { updateUserProfile } from 'app/common/api/common-api';
import AcceptInvite from 'app/components/settings/accept-invite';
import { getBasicAccountInfo } from 'app/selectors/user';

const mapStateToProps = (state, ownProps) => ({
  inviterName: ownProps.location.query.inviter,
  initialValues: getBasicAccountInfo(state),
  userSubmitError: _.get(state, 'common.userSubmitError'),
});

const mapDispatchToProps = (dispatch, props) => ({
  // The (valid, pending) invitation token is necessary to authorize the user to
  // update their password
  onSubmit: values => dispatch(updateUserProfile({
    ...values, invitation: props.location.query.invitation,
  })).then(() => dispatch(goto('/setup/terms-and-conditions?entry=new_user'))),
});

const AcceptInviteContainer = connect(mapStateToProps, mapDispatchToProps)(AcceptInvite);

export default AcceptInviteContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/accept-invite.js